import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  :host([hidden]) {
    display: none;
  }

  cse-image,
  csc-lightbox-zoom,
  cse-video {
    width: 100%;
    height: 100%;
    display: block;
  }

  .video-poster {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    background: #000000;
    cursor: pointer;
  }

  .video-poster__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
    pointer-events: none;
  }
`
